import { bookingGuestTranslations } from './translations';

/** Missing guest counts remain unknown in displays and write flows. */
export function knownGuestCount(value?: number): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0;
}
export function bookingGuestLabel(value?: number, unit: 'guests' | 'persons' = 'guests'): string {
  const text = bookingGuestTranslations.de;
  if (!knownGuestCount(value)) return text.unknown;
  return `${value} ${unit === 'persons' ? (value === 1 ? text.person : text.persons) : (value === 1 ? text.guest : text.guests)}`;
}

/** Legacy dashboard placeholders represent absent data, not guest names. */
export function guestNameValue(value?: string | null): string {
  const name = senderNameLabel(value);
  return ['Unknown Guest', 'Gastname unbekannt', 'Gast unbekannt', 'Unbekannter Gast'].includes(name) ? '' : name;
}
/** Empty provider suffixes are display artifacts; keep meaningful parentheses. */
export function senderNameLabel(value?: string | null): string {
  return (value ?? '').replace(/\s*\(\s*\)/g, '').trim();
}
export function bookingGuestNameLabel(booking: { guestName?: string | null; guest?: { fullName?: string | null } }): string {
  return guestNameValue(booking.guest?.fullName) || guestNameValue(booking.guestName) || bookingGuestTranslations.de.nameUnknown;
}
